<!--理财-->
<template>
    <div class="id">
        <div class="boxTop">
            <div class="boxItem" @click="currency = true">
                <div class="boxCode"> {{ productInfo.title }} </div>
                <div class="boxAmount" :style="{ color: '#00f0ff' }">{{ productInfo.price }}</div>
                <div class="boxProportion" :style="{ color: productInfo.price_zf > 0 ? '#00f0ff' : '#ff4834' }">
                    {{ productInfo.price_zf }}%</div>
            </div>
            <div class="boxItemS">
                <div class="boxText">
                    <div>{{ $t('最高价') }}</div>
                    <div>{{ productInfo.price_high }}</div>
                </div>
                <div class="boxText">
                    <div>{{ $t('最低价') }}</div>
                    <div>{{ productInfo.price_low }}</div>
                </div>
                <div class="boxText">
                    <div>24H{{ $t('量') }}</div>
                    <div>{{ productInfo['24hl'] }}k</div>
                </div>
                <div class="boxText">
                    <div>24H{{ $t('交易额') }}</div>
                    <div>{{ productInfo['24hjye'] }}b</div>
                </div>
            </div>
        </div>
        <div class="switch">
            <div v-for="(value, index) in productInfo.periodList" :key="index" @click="switchC(value, index)"
                :class="{ colost: swindex == index }">
                {{ value.value }}
            </div>
        </div>

        <div class="head">
            <keep-alive>
                <kLine ref="kLine" @close="getClose" :period="timeValue" :symbol="code" :price="productInfo.price"
                    :high="productInfo.price_high" :low="productInfo.price_low"></kLine>
            </keep-alive>
            <van-tabs v-model="actives" @change="onChangeS" background="#000" title-active-color="#ffffff"
                title-inactive-color="#888" color="#dfdfdf">
                <van-tab v-for="(item, index) in sourceS" :key="index" :title="item.name">
                    <div class="scroll" v-if="orderListS.length > 0">
                        <div v-if="actives == 0 || actives == 3">
                            <div v-for="value in orderListS" :key="value.id" class="boxS">
                                <div class="boxItem">
                                    <div>
                                        {{ value.product_title }}
                                        <span style="padding-left: 10px;color: #00f0ff;">
                                            {{ value.direction == 1 ? $t('买入') : $t('卖出') }}
                                        </span>
                                    </div>
                                </div>
                                <div class="boxItem">
                                    <div>{{ $t('开仓时间') }}</div>
                                    <div>{{ value.opentime_text }}</div>
                                </div>
                                <div class="boxItem">
                                    <div>{{ $t('数量') }}</div>
                                    <div>{{ value.number }}</div>
                                </div>
                                <div class="boxItem">
                                    <div>{{ $t('收益') }}(USDT) </div>
                                    <div>{{ value.fast_profits }}</div>
                                </div>
                                <div class="boxItem">
                                    <div>{{ $t('保证金率') }}</div>
                                    <div>{{ value.margin_rate }}%</div>
                                </div>
                                <div class="boxItem">
                                    <div>{{ $t('初始保证金') }}</div>
                                    <div>{{ value.margin_amount }}</div>
                                </div>
                                <div class="boxItem">
                                    <div>{{ $t('买入价格') }}</div>
                                    <div>{{ value.limit_price }}</div>
                                </div>
                                <div class="boxItem">
                                    <div>{{ $t('强制平仓价') }}</div>
                                    <div>{{ value.end_price }}</div>
                                </div>
                                <div class="btnC" v-if="actives == 0">
                                    <div @click="closePositions(value)">{{ $t('市价全平') }}</div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div v-for="value in orderListS" :key="value.id" class="boxS">
                                <div class="boxItem">
                                    <div>
                                        {{ value.product_title }}
                                        <span style="padding-left: 10px;color: #00f0ff;">
                                            {{ value.direction == 1 ? $t('买入') : $t('卖出') }}
                                        </span>
                                    </div>
                                    <div class="boxCd" @click="cancelOrder(value)" v-if="actives == 1">{{ $t('撤单') }}
                                    </div>
                                </div>
                                <div class="boxItem">
                                    <div>{{ $t('委托时间') }}</div>
                                    <div>{{ value.createtime_text }}</div>
                                </div>
                                <div class="boxItem">
                                    <div>{{ $t('委托总数量') }}</div>
                                    <div>{{ value.number }}</div>
                                </div>
                                <div class="boxItem">
                                    <div>{{ $t('委托价格') }}</div>
                                    <div>{{ value.limit_price }}</div>
                                </div>
                                <div class="boxItem">
                                    <div>{{ $t('成交价格') }}</div>
                                    <div>{{ value.open_price }}</div>
                                </div>
                                <div class="boxItem">
                                    <div>{{ $t('已完成量') }}</div>
                                    <div>{{ value.complete_number }}</div>
                                </div>
                                <div class="boxItem">
                                    <div>{{ $t('类型') }}</div>
                                    <div>{{ value.type_text }}</div>
                                </div>
                                <div class="boxItem">
                                    <div>{{ $t('状态') }}</div>
                                    <div>{{ value.status_text }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <van-empty :description="$t('暂无数据')" v-else />
                </van-tab>
            </van-tabs>
        </div>

        <div class="contentS">
            <div @click="showPopup = true">{{ $t('买进(做多)') }}</div>
            <div @click="showPopup = true">{{ $t('卖出(做空)') }}</div>
        </div>
        <van-popup v-model="showPopup" position="bottom" closeable close-icon="close" :style="{ height: '94%' }">
            <div class="popupId">
                <van-tabs v-model="activeCk" @change="onChangeCk" background="#12141e" title-active-color="#ffffff"
                    title-inactive-color="#888" color="#dfdfdf">

                    <van-tab v-for="(item, index) in sourceW" :key="index" :title="item.name">

                        <div class="lever">{{ $t('调整杠杆') }}</div>
                        <div class="switchS">
                            <div v-for="(item, index) in leverList" :key="index" class="leverC"
                                :class="{ colost: leverIndex == index }" @click="leverCk(index)">
                                {{ item.text }}
                            </div>
                        </div>

                        <div class="intervals" v-show="activeCk == 0">
                            <van-field :label="$t('价格') + '(USDT)'" :placeholder="$t('以当前市场最优价格下单')" label-width="130px"
                                input-align="right" label-align="left" disabled>
                            </van-field>
                        </div>
                        <div class="intervals" v-show="activeCk == 1">
                            <van-field v-model="amount" :label="$t('价格') + '(USDT)'" :placeholder="$t('请输入')"
                                label-width="130px" input-align="right" label-align="left">
                            </van-field>
                            <div class="boxs">{{ $t('对手价') }}</div>
                        </div>

                        <div class="intervals">
                            <van-field v-model="quantity" :label="$t('数量')" type="digit" :placeholder="$t('请输入')"
                                label-width="130px" input-align="right" label-align="left">
                            </van-field>
                            <div class="boxs">{{ $t('张') }}</div>
                        </div>
                        <div class="balance">
                            <span>{{ $t('可用') }}</span>
                            {{ moneyS }} (USDT)
                        </div>
                        <div style="display: flex;">
                            <van-checkbox v-model="takeProfit" shape="square" checked-color="#00f0ff" icon-size="16">{{
                                $t('止盈') }}</van-checkbox>
                            <van-checkbox v-model="stopLoss" shape="square" checked-color="#00f0ff" icon-size="16"
                                style="margin-left: 10px;">{{ $t('停损') }}</van-checkbox>

                        </div>
                        <div class="intervals" v-if="takeProfit">
                            <van-field v-model="takeV" :label="$t('止盈触发价')" placeholder="0" label-width="130px"
                                input-align="right" label-align="left">
                            </van-field>
                            <van-field v-model="takeIncrease" :placeholder="$t('涨幅')"
                                style=" width: 150px;margin-left: 20px;">
                                <template #button>
                                    <span style="color: #888;">%</span>
                                </template>
                            </van-field>

                        </div>
                        <div class="intervals" v-if="stopLoss">
                            <van-field v-model="stopV" :label="$t('停损触发价')" placeholder="0" label-width="130px"
                                input-align="right" label-align="left">
                            </van-field>
                            <van-field v-model="stopIncrease" :placeholder="$t('跌幅')"
                                style=" width: 150px;margin-left: 20px;">
                                <template #button>
                                    <span style="color: #888;">%</span>
                                </template>
                            </van-field>
                        </div>
                        <div class="topBtn">
                            <div @click="buySell(1)">{{ $t('买进(做多)') }}</div>
                            <div @click="buySell(2)">{{ $t('卖出(做空)') }}</div>
                        </div>
                        <div class="intervals" style="justify-content: flex-start;font-size: 16px;">
                            <div style="color: #888;">{{ $t('可开张数') }}</div>
                            <div style="padding-left: 20px;">{{ (moneyS / productInfo.price).toFixed(2) }}{{ $t('张') }}
                            </div>
                        </div>
                        <!-- <div class="intervals" style="justify-content: flex-start;font-size: 16px;">
                            <div style="color: #888;">保证金</div>
                            <div style="padding-left: 20px;">&asymp; {{ (moneyS / productInfo.price).toFixed(2) }}USDT</div>
                        </div> -->
                        <!-- <div class="invest">
                            <div>现货交易说明</div>
                              <div class="item">
                                目前通常进行数字资产交易的方式为：法币购买稳定币USDT（USDT锚定美元，理论上1USDT=1美元），
                                之后再使用USDT作为基础货币进行比特币等数字资产的交易，这种以一种 币兑换另一种币的方式被称作“币币交易”或“现货交易”。
                            </div>
                        </div> -->
                    </van-tab>
                </van-tabs>
            </div>
        </van-popup>

        <van-popup v-model="currency" position="left" closeable class="currencyId">
            <div class="currencyId">
                <div class="table">
                    <!-- 表头 -->
                    <van-row class="header">
                        <van-col span="10" class="vanItem">{{ $t('币种') }}</van-col>
                        <van-col span="7" class="vanItem">{{ $t('收盘价') }}</van-col>
                        <van-col span="7" class="vanItem">{{ $t('市场交易') }}</van-col>
                    </van-row>
                    <!-- 数据 -->
                    <div class="scroll">
                        <van-row v-for="item in users" :key="item.id" class="row">
                            <van-col span="10" class="rowItem">
                                <van-image width="34" style="padding-left:6px;" :src="item.image" />
                                <div style="padding-left: 12px;font-size: 12px;">
                                    <div>{{ item.symbol }}</div>
                                    <div style="padding-top: 6px;">{{ item.currency }}</div>
                                </div>
                            </van-col>
                            <van-col span="7" style="text-align: center;">{{ item.open_price }}</van-col>
                            <van-col span="7" class="trade">
                                <div class="box" @click="trade(item)">{{ $t('交易') }}</div>
                            </van-col>
                        </van-row>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import { get, post } from '@/http/request'
import kLine from '@/common/mobile/kLine.vue'
import apis from '@/http/api'
export default {
    components: {
        kLine,
    },
    data() {
        return {
            takeProfit: false,
            takeIncrease: '',
            takeV: '',
            stopLoss: false,
            stopIncrease: '',
            stopV: '',
            currency: false,
            actives: 0,
            leverList: [
                {
                    text: '5X',
                    id: 5
                },
                {
                    text: '10X',
                    id: 10
                },
                {
                    text: '20X',
                    id: 5
                },
                {
                    text: '50X',
                    id: 50
                },
                {
                    text: '100X',
                    id: 100
                }],

            sourceS: [
                {
                    name: this.$t('当前持仓')
                },

                {
                    name: this.$t('当前委托')
                },
                {
                    name: this.$t('历史委托')
                },
                {
                    name: this.$t('历史成交')
                }],
            sourceW: [
                {
                    name: this.$t('市价委托')
                },
                {
                    name: this.$t('限价委托')
                }
            ],
            users: [],
            amount: '',
            quantity: '',
            intervalV: 0,
            schedule: 0,
            dataPopup: false,
            marks: {
                0: '0%',
                25: '25%',
                50: '50%',
                75: '75%',
                100: '100%'
            },
            showPopup: false,
            activeCk: 0,
            productInfo: {},
            code: 'BTC',
            timeValue: '1min',
            swindex: '0',
            topIndex: 0,
            leverIndex: 0,
            moneyS: '',
            orderListS: [],
			pay_password: '’'
        };
    },
    mounted() {
        // this.code = this.$route.query.code || "BTC"
        this.getProductInfo()
        this.productList()
        this.getUserInfo()
    },
    beforeUnmount() { },
    methods: {
        trade(item) {
            console.log(item.symbol);
            this.code = item.symbol
            this.getProductInfo()
        },

        async productList() {
            const res = await get('/product/getProductList', { type: 1, title: this.value })
            if (res.code == 1) {
                console.log(res.data, '444');
                this.users = res.data
                return
            }
            this.$toast(res.msg);
        },

        //委托切换
        onChangeS(name, title) {
            console.log("切换到1", name, title)
            this.contractOrderList()
        },
        //基础数据
        getProductInfo() {
            this.$refs.kLine.openKline()
            get(this.$apis.getProductInfo, {
                code: this.code
            }).then(res => {
                if (res.code == 1) {
                    this.productInfo = res.data
                    this.currency = false
                    this.contractOrderList()
                }
            })
        },
        //提交
        async buySell(direction) {
            const res = await post(apis.contractOrder, {
                product_id: this.productInfo.id,
                direction,
                lever: this.leverList[this.leverIndex].id,
                limit_price: this.amount,
                type: this.activeCk + 1,
                number: this.quantity,
                is_stop_profit: this.takeProfit ? 1 : 0,//zhixing 
                stop_profit_price: this.takeV,
                profit_rate: this.takeIncrease,
                is_stop_loss: this.stopLoss ? 1 : 0,//停损
                stop_loss_price: this.stopV,
                loss_rate: this.stopIncrease,
                model: 0,
				pay_password: this.pay_password
            })
            if (res.code == 1) {
                this.$toast(res.msg);
                setTimeout(() => {
                    this.getUserInfo()
                    this.contractOrderList()
                }, 1000)
                return
            }
        },
        //平仓

        async closePositions(item) {
            const res = await post(apis.closePositions, {
                order_id: item.id,
            })
            if (res.code == 1) {
                this.$toast(res.msg);
                setTimeout(() => {
                    this.getUserInfo()
                    this.contractOrderList()
                }, 1000)
                return
            }
        },
        //撤单
        async cancelOrder(item) {
            const res = await post(apis.cancelContractOrder, {
                order_id: item.id,
            })
            if (res.code == 1) {
                this.$toast(res.msg);
                setTimeout(() => {
                    this.getUserInfo()
                    this.contractOrderList()
                }, 1000)
                return
            }
        },

        //当前 历史列表
        async contractOrderList() {
            let res = await get(apis.contractOrderList, {
                limit: 9999,
                product_id: this.productInfo.id,
                label: this.actives + 1
            })
            if (res.code == 1) {
                this.orderListS = res.data.list
            }
        },
        //
        async getUserInfo() {
            const res = await get(apis.getUserInfo)
            if (res.code == 1) {
                this.moneyS = res.data.contract_account
                return
            }
        },
        getClose(e) {
            console.log(e)
        },
        //市价 限价 切换
        onChangeCk(name, title) {
            console.log("切换到", name, title)
            if (name == 0) {
                this.amount = ''
            }
        },

        //时间切换
        switchC(item, index) {
            this.timeValue = item.value
            this.swindex = index
        },
        //选择杠噶
        leverCk(index) {
            this.leverIndex = index
        }
    },
};
</script>
<style lang="less" scoped>
::v-deep .van-tabs__wrap {
    border-bottom: 1px solid #282838;
}

.currencyId {
    width: 100%;
    height: 100%;
    background-color: #000;
    padding: 26px 10px;

    .table {
        background: #000;
        color: #fff;

        .header {
            font-weight: bold;
            background: #1c222c;
            padding: 14px 0;
            border-radius: 5px;

            .vanItem {
                text-align: center;
            }
        }

        .scroll {
            overflow-y: auto;
            height: 85vh;
            scrollbar-width: none;
            -ms-overflow-style: none;
        }

        .row {
            border-bottom: 1px solid #222b39;
            padding: 20px 10px;
            display: flex;
            align-items: center;

            .rowItem {
                display: flex;
                align-items: center;
            }

            .trade {
                text-align: right;

                .box {
                    border: 1px solid #fff;
                    padding: 5px 20px;
                    border-radius: 5px;
                    display: inline-block;
                    font-size: 12px;
                }

            }
        }
    }
}

.popupId {
    background-color: #12141e;
    height: 94vh;
    padding: 26px 15px;

    ::v-deep .van-checkbox__label {
        color: #888;
    }

    .lever {
        padding: 20px 0;
        font-size: 16px;
    }

    .switchS {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #888;

        .leverC {
            text-align: center;
            padding: 5px 20px;
            border-radius: 10px;
            border: 1px solid #12141e;
        }

        .colost {
            border: 1px solid #01d1df;
        }
    }

    .topBtn {
        display: flex;
        justify-content: space-between;
        padding-top: 20px;

        div {
            width: 47%;
            text-align: center;
            color: #000;
            padding: 10px 0;
            border-radius: 20px;
        }

        div:nth-child(1) {
            background-color: #00f0ff;
        }

        div:nth-child(2) {

            background-color: #ff4834;
        }
    }


    .btn {
        display: flex;
        justify-content: center;
        margin: 20px 0;

        div {
            background-color: #00f0ff;
            width: 100%;
            color: #000;
            padding: 10px 0;
            font-size: 16px;
            border-radius: 10px;
            text-align: center;
        }
    }

    .invest {
        padding-top: 24px;
        margin-top: 20px;
        border-top: 1px solid #30313e;

        .item {
            margin-top: 20px;
            display: flex;
            align-items: center;
            color: #888;
        }
    }


    .balance {
        padding: 15px 0;
        font-size: 14px;

        span {
            padding-right: 10px;
            color: #888;
        }
    }

    .intervals {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        ::v-deep .van-cell {
            color: #fff;
            height: 50px;
            display: flex;
            align-items: center;
            border-radius: 5px;
        }

        .boxs {
            background-color: #000000;
            height: 50px;
            line-height: 50px;
            width: 100px;
            text-align: center;
            border-radius: 5px;
            margin-left: 20px;
        }
    }

    .interval {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #2a2a3b;
        padding: 0 20px;
        margin: 15px 0;
        color: #888;
        border-radius: 5px;
        height: 50px;

        ::v-deep .van-dropdown-menu__bar {
            background: #12141e;
        }

        ::v-deep .van-dropdown-menu__title {
            color: #fff;
        }

        ::v-deep .van-cell::after {
            border-bottom: 0px solid #000;
        }

        ::v-deep .van-cell {
            color: #fff;
            border: 1px solid #2a2a3b;
            height: 50px;
            display: flex;
            align-items: center;
        }

        ::v-deep .van-overlay {
            height: auto;
            background-color: #000;
        }

        ::v-deep .van-field__label {
            color: #888;
        }
    }
}

.id {
    color: #fff;
    padding: 0 15px;
    padding-top: 50px;
    padding-bottom: 60px;
    font-size: 14px;
    position: relative;

    .scroll {
        // overflow-y: auto;
        // height: 55vh;
        // scrollbar-width: none;
        // -ms-overflow-style: none;

        .boxS {
            border-bottom: 1px solid #222630;
            padding: 20px 10px;
            padding-bottom: 0;
            color: #888;

            .btnC {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                padding-bottom: 15px;

                div {
                    background-color: #fff;
                    padding: 5px 15px;
                    color: #000;
                    border-radius: 5px;
                }

                div:nth-child(2) {
                    margin-left: 20px;
                }
            }


            .boxItem {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-bottom: 15px;

                .boxCd {
                    background-color: #e5e5e5;
                    padding: 4px 15px;
                    color: #000 !important;
                    border-radius: 4px;
                    font-size: 12px;
                }

                div:nth-child(2) {
                    color: #fff;
                }
            }
        }
    }

    .switch {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 20px;
        color: #888;

        div {
            text-align: center;
        }

        .colost {
            color: #00f0ff;
        }
    }

    .boxTop {
        display: flex;
        padding-bottom: 25px;
        padding-top: 12px;

        .boxItem {
            width: 45%;

            .boxCode {
                font-size: 22px;
            }

            .boxAmount {
                padding: 15px 0;
                font-size: 15px;
            }

            .boxProportion {
                font-size: 12px;
            }
        }

        .boxItemS {
            width: 55%;
            color: #888;

            .boxText {
                display: flex;
                justify-content: space-between;
                padding-top: 4px;

            }
        }
    }


    .contentS {
        display: flex;
        justify-content: space-between;
        background: #000;
        padding: 15px;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0px;
        z-index: 88;
        border-top: 1px solid #181822;

        div {
            width: 47%;
            text-align: center;
            padding: 10px 0;
            border-radius: 10px;
            font-size: 16px;
        }

        div:nth-child(1) {
            background-color: #00f0ff;
            color: #000;
        }

        div:nth-child(2) {
            background-color: #ff4834;
        }
    }

}
</style>